
import { supabase } from "@/integrations/supabase/client";
import { getUserProducts } from "@/services/products.service";
import { addShoppingItem } from "@/services/shopping/items/index";
import logger from "@/utils/logger";
import { validateQuantity } from "@/utils/security";
import { getRecurringProducts } from "./recurring-products.service";

export const addRecurringProductToList = async (listId: string, productId: string): Promise<boolean> => {
  try {
    // Get recurring product to retrieve its attributes
    const recurringProducts = await getRecurringProducts();
    const recurringProduct = recurringProducts.find(p => p.product_id === productId);
    
    // Ottieni informazioni sul prodotto cercandolo nell'array dei prodotti dell'utente
    const products = await getUserProducts();
    const product = products.find(p => p.id === productId);
    
    if (!product) {
      logger.logError('recurringProducts','Prodotto non trovato',{additionalInfo:{productId}});
      return false;
    }
    
    // Aggiungi il prodotto alla lista della spesa
    const quantityValidation = validateQuantity(product.defaultQuantity ?? "1");

    if (!quantityValidation.isValid) {
      logger.logError('recurringProducts', 'Quantità ricorrente non valida', {
        additionalInfo: { quantity: product.defaultQuantity, error: quantityValidation.error }
      }).catch(() => {});
    }

    await addShoppingItem(listId, {
      product_id: productId,
      quantity: quantityValidation.isValid ? quantityValidation.sanitized : "1",
      unit: product.defaultUnit || "pz",
      category: product.categoryId || undefined,
      attributes: recurringProduct?.attributes || product.attributes // Use recurring product attributes, fallback to product attributes
    });
    
    return true;
  } catch (error) {
    logger.logError("recurringProducts","Errore aggiunta prodotto ricorrente",{additionalInfo:error});
    return false;
  }
};
